import { createAction, createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { apiRequest } from "services/ServiceUtil";
import { LIBRARY_SERVICE_METHOD } from "services/commonService";
import { PlanState } from "./plans";

const initialState: PlanState = {
  list: [],
  brandDeadlines: [],
  initiativePlans: [],
  totalRecords: 0,
  status: "idle",
  showDialog: false,
  errors: "",
  planShowLoader: false
  //add error field
  //test
};
const SLICE = "plans";

export const fetchPlansAsync = createAsyncThunk(`${SLICE}/fetchPlansAsync`, (data: any, thunkApi) => {
  const params = { externalHltId: data?.externalHltId || "" };
  return apiRequest(LIBRARY_SERVICE_METHOD.postPlans, data, thunkApi, [], params);
});

export const closeDialog = createAction("plans/clearState");

export const PlansSlice = createSlice({
  name: SLICE,
  initialState,
  reducers: {
    clearPlanList: (state) => {
      state.list = [];
    },
    setPlanList: (state, action) => {
      const { id, isBookmarked } = action.payload;
      state.list = state.list.map((item) => (item.id === id ? { ...item, isBookmarked } : item));
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(closeDialog, (state) => {
        state.showDialog = false;
      })
      .addCase(fetchPlansAsync.pending, (state, action: any) => {
        state.planShowLoader = action.meta.arg.pagination.page === 1;
        state.status = action.meta.arg.pagination.page === 1 ? "loading" : "idle";
      })
      .addCase(fetchPlansAsync.fulfilled, (state, action: any) => {
        state.planShowLoader = false;
        state.status = "idle";
        state.totalRecords = action?.payload?.meta?.page?.total;

        state.list =
          action.meta.arg.pagination.page === 1 ? action.payload.plans : [...state.list, ...action.payload.plans];
      })
      .addCase(fetchPlansAsync.rejected, (state) => {
        state.planShowLoader = false;
        state.status = "failed";
      });
  }
});

export const { clearPlanList, setPlanList } = PlansSlice.actions;

export default PlansSlice.reducer;
